import { NodeEditor } from 'rete';

import ReteInput, {
  ReteInputParams,
} from 'pipelines/services/rete/controls/input';

import { UpstreamModelLabels } from 'pipelines/components/UpstreamModelLabels/UpstreamModelLabels';

export default class ReteUpstreamModelLabelInput extends ReteInput {
  constructor(
    editor: NodeEditor,
    key: string,
    params: Omit<ReteInputParams, 'type'>
  ) {
    super(editor, key, { ...params, type: 'string', inputType: 'select' });
  }

  get component() {
    return UpstreamModelLabels;
  }
}
